/**
 * External dependencies
 */
import inherits from 'inherits';

export default class CurrentRental {
    constructor(cscom) {
        if (!(this instanceof CurrentRental)) {
            return new CurrentRental(cscom);
        }
        this.cscom = cscom;
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/rental/view', null, data);
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/rental/list', null, data);
    }

}
